module.exports = function() {
  return new Worker(__webpack_public_path__ + "47c77cdec44ab2259b7e.worker.js");
};